<ng-container *ngIf="data && type" [ngSwitch]="type">
    <div *ngIf="isSupportedType" class="viewer-container h-100">
        <!-- Use an iframe wrapper to avoid iframe height bug on iOS Safari. -->
        <pre *ngSwitchCase="'txt'" class="overflow-auto">{{ data }}</pre>
        <pre *ngSwitchCase="'json'" class="overflow-auto pb-3">{{ data | json }}</pre>
        <ca-csv-table *ngSwitchCase="'csv'" [data]="data"></ca-csv-table>
    </div>
    <div *ngSwitchCase="'html'" class="h-100 overflow-auto">
        <ca-html-preview-frame [dataToRender]="data"></ca-html-preview-frame>
    </div>
    <div *ngSwitchDefault>
        <p>
            File type <b>{{ type }}</b> is not supported by previewer. You can download it <a [href]="data" target="_blank">here</a>.
        </p>
    </div>
</ng-container>
